import { GridCellState } from "../GridCellState";
import { Clue } from "../models/clue";
import { DeAtted } from "./misc";

export function AmendedGridStateFromUpdate(
  prevGrid: GridCellState[][],
  update: string
): GridCellState[][] {
  const newGrid = prevGrid.map((row) => row.slice());
  let i = 0;
  for (let row = 0; row < newGrid.length; row++) {
    for (let col = 0; col < newGrid[row].length; col++) {
      const refCopy = newGrid[row][col];
      const cellToUpdate: GridCellState = {
        ...refCopy,
        setContainingClueNum: refCopy.setContainingClueNum,
        isBlack: refCopy.isBlack,
        getText: refCopy.getText,
        getClass: refCopy.getClass,
        PersistenceText: refCopy.PersistenceText,
      };
      cellToUpdate.userText = DeAtted(update[i]);
      cellToUpdate.enteringUserKey = DeAtted(update[i + 1]);
      newGrid[row][col] = cellToUpdate;
      i += 2;
    }
  }
  return newGrid;
}

export function clueString(clue: Clue | undefined): string {
  if (!clue){
    return "Clue not found";
  }
  const clueEncoded = String.fromCharCode(
    (clue.isAcross ? 65 : 97) + clue.clueNumber - 1
  );
  if (clue.group && clue.group.length > 1 && clue.group[0] === clueEncoded) {
    return (
      clue.group
        .split("")
        .map((letter) => {
          // If lowercase, convert to uppercase and shift by 2 positions (with wrap-around)
          if (letter >= "a") {
            const num = letter.charCodeAt(0) - "a".charCodeAt(0) + 1;
            return `${num}D`;
          } else {
            const num = letter.charCodeAt(0) - "A".charCodeAt(0) + 1;
            return `${num}A`;
          }
        })
        .join(", ") +
      ". " +
      clue.clueText
    );
  } else {
    return clue.clueNumber + ". " + clue.clueText;
  }
}

export function clueDividers(
  acrossClue: Clue | null,
  downClue: Clue | null,
  row: number,
  col: number
): string {
  const posInAcrossClue = col - (acrossClue?.column ?? 0) + 1;
  const posinDownClue = row - (downClue?.row ?? 0) + 1;

  let result = "";

  let pos;
  for (const wl of acrossClue?.wordLengths ?? []) {
    pos = wl.length;
    if (pos === posInAcrossClue) {
      result += "right-line ";
    }
    if (pos === posInAcrossClue - 1) {
      result += "left-line ";
      break;
    }
  }

  for (const wl of downClue?.wordLengths ?? []) {
    pos = wl.length;
    if (pos === posinDownClue) {
      result += "bottom-line ";
      break;
    }
    if (pos === posinDownClue - 1) {
      result += "top-line ";
      break;
    }
  }
  return result;
}

